import { PaginationFilters } from '../new/paginationFilters';
import { Role } from './role.type';
import { UserProfile } from './user-profile.type';

export type UserProfileRole = {
	id: number;
	role: Role;
	userProfile: UserProfile;
};

export class UserProfileRoleFilters extends PaginationFilters {
	constructor(init?: Partial<UserProfileRoleFilters>) {
		super(init);
		Object.assign(this, init);
	}
}
